import { render, staticRenderFns } from "./CardSerieList.vue?vue&type=template&id=0c95b9f6&"
import script from "./CardSerieList.vue?vue&type=script&lang=js&"
export * from "./CardSerieList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports